<template>
    <div class="features-list">
        <p class="sidebar-helptext">{{ $t('model.nlu-model.sidebar.features.list.featurelist.addFeaturesTo') }}</p>
        <div
            v-if="status.fetching"
            class="features-list--loader"
        >
            <span class="no-features-text">{{ $t('model.nlu-model.sidebar.features.list.featurelist.loadingFeatures') }}</span>
        </div>
        <div
            v-else-if="!isCurrentKMWithEntityExtractions"
            class="features-list--not-available"
        >
            <span class="no-features-text not-available-text">{{ $t('model.nlu-model.sidebar.features.list.featurelist.featuresAreNot') }}</span>
        </div>
        <div
            v-else-if="features.length === 0"
            class="features-list--empty-body"
        >
            <span class="no-features-text">{{ $t('model.nlu-model.sidebar.features.list.featurelist.youHaveNo') }}</span>
            <or-button
                type="secondary"
                color="primary"
                size="small"
                class="flat create-btn"
                disabledRipple
                @click="createNewEntity"
            >{{ $t('model.nlu-model.sidebar.features.list.featurelist.addFeature') }}</or-button>
        </div>
        <div
            v-else
            class="features-list--body"
        >
            <or-search-box
                v-model="searchText"
                class="search"
                :placeholder-text="$t('model.nlu-model.sidebar.features.list.featurelist.search')"
            />
            <or-button
                type="secondary"
                color="primary"
                icon="add"
                size="small"
                class="flat create-btn"
                disabledRipple
                @click="createNewEntity"
            >{{ $t('model.nlu-model.sidebar.features.list.featurelist.newFeature') }}</or-button>
            <div class="features-list">
                <div
                    v-for="item in filteredFeatures"
                    :key="item.id"
                    class="feature-item"
                >
                <span
                    class="feature-name"
                    @click="editFeature(item)"
                >
                    {{item.name}}
                </span>

                    <div class="feature-options-label">
                    <span v-if="item.enabledForAllModels">{{ $t('model.nlu-model.sidebar.features.list.featurelist.global') }}</span>
                        <span v-if="item.mode">{{ $t('model.nlu-model.sidebar.features.list.featurelist.interchangeable') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'FeaturesList',

  data () {
    return {
      searchText: ''
    }
  },

  computed: {
    ...mapState('knowledgebase/features', ['features', 'status']),
    ...mapGetters('knowledgebase', ['isCurrentKMWithEntityExtractions']),

    filteredFeatures () {
      return this.features.filter(({ name }) => name.includes(this.searchText))
    }
  },

  methods: {
    createNewEntity () {
      this.$emit('create')
    },

    editFeature (feature) {
      this.$emit('edit', feature)
    }
  }
}
</script>

<style scoped lang="scss">
    .features-list {
        height: 100%;

        .features-list--empty-body, .features-list--not-available, .features-list--loader {
            height: 80%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .no-features-text {
                color: rgb(30, 35, 43);
                font-size: 14px;
                font-weight: 600;
                text-align: center;
            }
            .not-available-text {
                font-weight: bold;
            }
        }

        .sidebar-helptext {
            margin: $sp-3 0;
        }

        .features-list--body {
            height: 100%;
            .search {
                margin-right: $sp-2;
                height: 36px;
            }

            .create-btn {
                margin: $sp-3 0 0 0;
                padding-left: 0;
            }

            .features-list {
                display: flex;
                flex-grow: 1;
                margin-top: $sp-2;
                flex-direction: column;
                overflow: auto;

                .feature-item:not(:first-child) {
                    margin: $sp-3 0 0;
                }

                .feature-item {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .feature-name {
                        font-size: 14px;
                        font-weight: 600;
                        color: $or-black-blue;

                        &:hover {
                            color: $or-blue;
                            cursor: pointer;
                            transition: all .2s ease;
                        }
                    }
                }
            }

            .feature-options-label {
                color: rgb(145, 150, 157);
                font-size: 14px;
                font-weight: normal;
                text-align: center;

                span:nth-child(2) {
                    margin-left: $sp-3;
                }
            }
        }
    }
</style>
